import { useCheckIn } from './useCheckIn'
import { useCheckOut } from './useCheckOut'
import { useMyAvailableTasks } from './useMyAvailableTasks'
import { usePing } from './usePing'
import { useSkyView } from './useSkyView'

export const dispatcher = {
  skyView: useSkyView,
  myAvailableTasks: useMyAvailableTasks,
  ping: usePing,
  checkIn: useCheckIn,
  checkOut: useCheckOut,
}
